module.exports = __webpack_public_path__ + "img/tag.bbcd51ef.svg";